import { useEffect } from 'react';
import { acquireWakeLock, releaseWakeLock } from '../utils/wake-lock';

/**
 * Keeps the screen awake while `active` is true — e.g. during a long video
 * upload, so the device doesn't sleep and interrupt it. Delegates to the shared
 * screen wake lock (see utils/wake-lock), so it coexists with other holders such
 * as the workout timer. No-op where the Wake Lock API is unavailable or denied.
 */
export function useWakeLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;

    // A per-mount token so releasing this lock never drops another holder's.
    const owner = Symbol('use-wake-lock');
    void acquireWakeLock(owner);

    // Browsers drop the lock when the tab is hidden; re-acquire once visible.
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') void acquireWakeLock(owner);
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      void releaseWakeLock(owner);
    };
  }, [active]);
}
